const storage = {
    AUTH_STORAGE_KEY: 'MSALAuth'
};

export default storage;
